import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Col } from 'react-bootstrap'

function RemesasMensuales ({ mensuales, mesAnterior }) {
  return (

    <Card className='card-stats'>
      <Card.Body>
        <div className='row'>
          <Col xs='5'>
            <div className='icon-big text-center icon-warning'>
              <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#2596be' }} />
            </div>
          </Col>
          <Col xs='7'>
            <div className='numbers'>
              <p className='card-category'>Comparativa mes anterior</p>
              <Card.Title as='h4'>{mensuales || '⌛'}/ {mesAnterior || '⌛'}</Card.Title>
            </div>
          </Col>
        </div>
      </Card.Body>
    </Card>
  )
}

export default RemesasMensuales
